// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactList_list__37zoA","item":"ContactList_item__32KCZ","button":"ContactList_button__7KPEB"};